'use strict';

module.exports = (function () {
	function _isCrossDomain(url) {
		return !url.match(document.domain);
	}

	function _get(url, successFn, errFn, parseJson) {
		var req;

		if (_isCrossDomain(url) && window.XDomainRequest) {
			req = new XDomainRequest();

			if(!errFn) {
				errFn = function () {
				    // empty
                };
			}

			req.timeout = 10000;

			req.onprogress = function () {
			    // empty
            };

			req.ontimeout = errFn.bind(this, 'timeout');

			req.onerror = errFn.bind(this, 'error');

			req.onload = function () {
				successFn(parseJson ? JSON.parse(req.responseText) : req.responseText);
			};
		} else {
			req = new XMLHttpRequest();
			req.onreadystatechange = function () {
				if (req.readyState === 4) {
					if (req.status === 200) {
						successFn(parseJson ? JSON.parse(req.responseText) : req.responseText, req);
					} else if (errFn) {
						errFn('http', req);
					}
				}
			};

			if (errFn) {
				req.onerror = errFn.bind(this, 'error');
				req.ontimeout = errFn.bind(this, 'timeout');
			}
		}

		req.open('GET', url, true);
		req.send(null);
	}

	return {
		getText: function (url, successFn, errFn) {
			_get(url, successFn, errFn, false);
		},

		getJson: function (url, successFn, errFn) {
			_get(url, successFn, errFn, true);
		},

		ping: function (url, successFn, errFn) {

			var req;

			if (_isCrossDomain(url) && window.XDomainRequest) {
				req = new XDomainRequest();
				req.onload = function () {
					successFn();
				};
			} else {
				req = new XMLHttpRequest();
				req.onreadystatechange = function () {
					if (req.readyState === 4) {
						if (req.status === 200) {
							successFn();
						} else {
							errFn();
						}
					}
				};
			}

			req.onerror = errFn;
			req.ontimeout = errFn;
			req.open('GET', url, true);
			req.send(null);
		},

		postJSON: function (url, data, successFn, errFn) {

			var req;

			if (_isCrossDomain(url) && window.XDomainRequest) {
				req = new XDomainRequest();
				req.onload = function () {
					successFn();
				};
			} else {
				req = new XMLHttpRequest();
				req.onreadystatechange = function () {
					if (req.readyState === 4) {
						if (req.status === 200) {
							successFn();
						}
					}
				};
			}

			req.onerror = errFn;
			req.ontimeout = errFn;
			req.open('POST', url, true);
			req.setRequestHeader('Content-type', 'application/json');
			req.send(JSON.stringify(data));
		}

	};
})();



// WEBPACK FOOTER //
// ./src/js/util/request.js